import * as enm from "lib/enum"
const crud = enm.DefineEnum(["Create", "Read", "Update", "Delete"] as const)
export type Crud = enm.VariantOf<typeof crud>

export const { Create, Read, Update, Delete } = crud
